import { forwardRef, HTMLAttributes, memo, ReactNode } from "react";
import classnames from "classnames";
import { StepIconBase, StepIconBaseSize, StepIconBaseStatus } from "./StepIconBase";

import styles from "./style.module.scss";

export type StepBaseType =
  | "line"
  | "iconTop"
  | "iconLeft"
  | "iconOnly"
  | "featuredIconTop"
  | "featuredIconLeft"

export type ProgressStepBaseProps = {
  type?: StepBaseType
  text?: string | ReactNode
  icon?: ReactNode
  size?: StepIconBaseSize
  status?: StepIconBaseStatus
  connector?: boolean
  supportingText?: string | ReactNode
  connectorClassName?: string
  textWrapperClassName?: string
  iconWrapperClassName?: string
  featuredIconWrapperClassName?: string
} & HTMLAttributes<HTMLButtonElement>

export const StepBase = memo(
  forwardRef<HTMLButtonElement, ProgressStepBaseProps>(
    (
      {
        type = "line",
        text,
        icon,
        size = "sm",
        connector = true,
        className,
        supportingText,
        status = "incomplete",
        connectorClassName,
        textWrapperClassName,
        iconWrapperClassName,
        featuredIconWrapperClassName,
        ...props
      },
      ref,
    ) => {
      return (
        <button
          className={classnames(
            className,
            styles.root,
            styles[size as keyof typeof styles],
            styles[type as keyof typeof styles],
            styles[status as keyof typeof styles], {
              [styles.connector]: connector,
            },
          )}
          {...props}
          ref={ref}
        >
          {
            type !== "line" &&
            <div className={classnames(iconWrapperClassName, styles.iconWrapper)}>
              {
                (type === "featuredIconTop" || type === "featuredIconLeft") ?
                  <span className={classnames(featuredIconWrapperClassName, styles.featuredIconWrapper)}>{icon}</span> :
                  <StepIconBase size={size} status={status} className={styles.iconBase} />
              }
            </div>
          }
          {
            type !== "iconOnly" && (
              <div className={classnames(textWrapperClassName, styles.textWrapper)}>
                <p className={styles.text}>{text}</p>
                <p className={styles.supportingText}>{supportingText}</p>
              </div>
            )
          }
        </button>
      );
    },
  ),
);
